export default __webpack_public_path__ + "static/media/waveL.a392aee0.png";